import axios from 'axios';
import {
  AI_PROMPT_BUILDER_CREATE_BULK_COLLECTIONS_BEGIN,
  AI_PROMPT_BUILDER_CREATE_BULK_COLLECTIONS_SUCCESS,
  AI_PROMPT_BUILDER_CREATE_BULK_COLLECTIONS_FAILURE,
  AI_PROMPT_BUILDER_CREATE_BULK_COLLECTIONS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';

export function createBulkCollections(args = {}) {
  return (dispatch) => {
    dispatch({
      type: AI_PROMPT_BUILDER_CREATE_BULK_COLLECTIONS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/create-bulk`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: AI_PROMPT_BUILDER_CREATE_BULK_COLLECTIONS_SUCCESS,
            data: res,
          });
          resolve(res);
          toast.success('Collection Created Successfully!');
        },
        (err) => {
          dispatch({
            type: AI_PROMPT_BUILDER_CREATE_BULK_COLLECTIONS_FAILURE,
            data: { error: err },
          });
          reject(err);
          toast.error('Failed to create the collection. Please try again.');
        },
      );
    });

    return promise;
  };
}

export function dismissCreateBulkCollectionsError() {
  return {
    type: AI_PROMPT_BUILDER_CREATE_BULK_COLLECTIONS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case AI_PROMPT_BUILDER_CREATE_BULK_COLLECTIONS_BEGIN:
      return {
        ...state,
        createBulkCollectionsPending: true,
        createBulkCollectionsError: null,
      };

    case AI_PROMPT_BUILDER_CREATE_BULK_COLLECTIONS_SUCCESS:
      return {
        ...state,
        createBulkCollectionsPending: false,
        createBulkCollectionsError: null,
      };

    case AI_PROMPT_BUILDER_CREATE_BULK_COLLECTIONS_FAILURE:
      return {
        ...state,
        createBulkCollectionsPending: false,
        createBulkCollectionsError: action.data.error,
      };

    case AI_PROMPT_BUILDER_CREATE_BULK_COLLECTIONS_DISMISS_ERROR:
      return {
        ...state,
        createBulkCollectionsError: null,
      };

    default:
      return state;
  }
}
